import React from 'react'
import { Column } from 'src/components/Layout/Styled'
import { Typography } from '@mui/material'
import Summary from './Summary'
import EnrollInfo from './EnrollInfo'

const Confirmation = () => {
  return (
    <Column>
      <Typography variant="h6" sx={{ mb: 4 }}>
        ยืนยันข้อมูลการสมัครเข้าอบรม
      </Typography>
      <Summary />
      <EnrollInfo />
    </Column>
  )
}

export default Confirmation
